export enum StageEnum {
  RequestEmail = 1,
  EmailSent = 2,
  RequestSMSToken = 3,
  ErrorSendSMS = 4,
  ErrorSendEmail = 5,
}
